import { Request } from '../../../httpClient/serverApi/requests/Request';
import { ISharedWithMeCustomViewInfo } from '../../models/ISharedWithMeContentInfo';
import { IUserInfo } from '../../models/IUserInfo';
import { IContent } from '../types/IContent';
import { IGetItemsParams } from '../types/IGetItemsParams';
import { IGetItemsResult } from '../types/IGetItemsResult';

export interface IShareAction {
  id: string;
  contentId: number;
  contentType: string;
  createdAt: string;
  isSharerDeleted: boolean;
  message: string;
  sharerId: number;
  underhoodCustomizedViewId?: string;
}

// getSharedWithMe API response interface
export interface IGetSharedWithMeResult extends IGetItemsResult {
  content: IContent[];
  deletedSharers: IUserInfo[];
  owners: IUserInfo[];
  sharers: IUserInfo[];
  shareActions: IShareAction[];
  viewsWithShareActivity: number[];
  underhoodCustomizedViews: ISharedWithMeCustomViewInfo[];
}

export class GetSharedWithMeRequest extends Request<IGetItemsParams, IGetSharedWithMeResult> {
  constructor(params: IGetItemsParams) {
    super('getSharedWithMe', params);
  }
}
